import { writable } from 'svelte/store';
import { TokenSession } from '$shared/api/tokenSession';
import type { UserDto } from '$shared/dto/user.dto';

/** The signed-in system admin, or null. */
export const user = writable<UserDto | null>(null);

/**
 * Books' login. The API is same-origin (this app and the API are served by
 * the same server), so paths are relative to the site root. Tokens are kept
 * under their own prefix and are a Books session of their own: signing in or
 * out here never touches a MarketEdge session.
 */
export const session = new TokenSession({
    apiBase: '/',
    app: 'books',
    storagePrefix: 'books.',
    onUser: (u) => user.set(u)
});

/**
 * Restores the session on page load from the stored refresh token. Books is
 * reached only by signing in here; MarketEdge has no way in.
 */
export async function restoreSession(): Promise<void> {
    if (session.hasTokens()) await session.refresh();
}
